import statsCustomer from "../../api/statsCustomer";

export default {
  namespaced: true,
  state: {
    items: [],
    statsCustomer: {},
    statsForAdmin: {},
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setStatsCustomer(state, statsCustomer) {
      state.statsCustomer = statsCustomer;
    },
    setStatsForAdmin(state, statsForAdmin) {
      state.statsForAdmin = statsForAdmin;
    },
  },
  actions: {
    recalculatePoints({ commit }, data) {
      return statsCustomer.recalculatePoints(data).then((response) => {
        if (response.data != "" && response.data.statsContract) {
          const dataStats = response.data.statsContract;
          dataStats.names = response.data.subFranchises.names || [];
          dataStats.totals = response.data.subFranchises.totals || [];
          dataStats.gimCustomNames =
            response.data.subFranchises.gimCustomNames || [];
          dataStats.gimCustomTotals =
            response.data.subFranchises.gimCustomTotals || [];
          dataStats.gimCustomPreviousYearNames =
            response.data.subFranchises.gimCustomPreviousYearNames || [];
          dataStats.gimCustomPreviousYearTotals =
            response.data.subFranchises.gimCustomPreviousYearTotals || [];
          dataStats.cost = response.data.deliveryCostAndBillingFees || [];
          dataStats.customer = response.data.customer;
          commit("setStatsCustomer", dataStats);
        } else {
          // Set default values when statsCustomer is null
          const statsNull = {
            capitalPoints: 0,
            implantPoints: 0,
            servicePoints: 0,
            manualPoints: 0,
            consommablePoints: 0,
            totalPoints: 0,
            totalPastYear: 0,
            statusPastYear: -1,
            totalCurrentYear: 0,
            customer: response.data.customer,
            names: [],
            totals: [],
          };
          commit("setStatsCustomer", statsNull);
        }
        return response;
      });
    },
    fetchAll({ commit }, data) {
      return statsCustomer.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    updatePoints({ dispatch }, data) {
      return statsCustomer.updatePoints(data).then((response) => {
        dispatch("fetChSpecificStatsCustomer", { id: data.customerId });
        return response;
      });
    },
    fetChSpecificStatsCustomer({ commit }, dataCustomer) {
      return statsCustomer.getByCustomerId(dataCustomer.id).then((response) => {
        if (response.data != "" && response.data.statsContract) {
          const dataStats = response.data.statsContract;
          dataStats.names = response.data.subFranchises.names || [];
          dataStats.totals = response.data.subFranchises.totals || [];
          dataStats.gimCustomNames =
            response.data.subFranchises.gimCustomNames || [];
          dataStats.gimCustomTotals =
            response.data.subFranchises.gimCustomTotals || [];
          dataStats.gimCustomPreviousYearNames =
            response.data.subFranchises.gimCustomPreviousYearNames || [];
          dataStats.gimCustomPreviousYearTotals =
            response.data.subFranchises.gimCustomPreviousYearTotals || [];
          dataStats.cost = response.data.deliveryCostAndBillingFees || [];
          dataStats.customer = response.data.customer;
          commit("setStatsCustomer", dataStats);
          if (dataCustomer.name != "admin") {
            commit("users/setSelectedCustomer", response.data.customer, {
              root: true,
            });
          }
        } else {
          // Set default values when statsCustomer is null
          const statsNull = {
            capitalPoints: 0,
            implantPoints: 0,
            servicePoints: 0,
            manualPoints: 0,
            consommablePoints: 0,
            totalPoints: 0,
            totalPastYear: 0,
            statusPastYear: -1,
            totalCurrentYear: 0,
            customer: response.data.customer,
            names: [],
            totals: [],
          };
          commit("setStatsCustomer", statsNull);
          if (dataCustomer.name != "admin") {
            commit("users/setSelectedCustomer", response.data.customer, {
              root: true,
            });
          }
        }
        return response;
      });
    },
    fetchSpecificOrRecalculate({ commit }, dataCustomer) {
      return statsCustomer
        .getByCustomerAdmin(dataCustomer.id)
        .then((response) => {
          if (response.data != "" && response.data.statsContract) {
            const dataStats = response.data.statsContract;
            dataStats.names = response.data.subFranchises.names || [];
            dataStats.totals = response.data.subFranchises.totals || [];
            dataStats.gimCustomNames =
              response.data.subFranchises.gimCustomNames || [];
            dataStats.gimCustomTotals =
              response.data.subFranchises.gimCustomTotals || [];
            dataStats.gimCustomPreviousYearNames =
              response.data.subFranchises.gimCustomPreviousYearNames || [];
            dataStats.gimCustomPreviousYearTotals =
              response.data.subFranchises.gimCustomPreviousYearTotals || [];
            dataStats.cost = response.data.deliveryCostAndBillingFees || [];
            dataStats.customer = response.data.customer;
            commit("setStatsCustomer", dataStats);
          }
          return response;
        });
    },
    /**
     * Récupère les statistiques d'un contrat spécifique
     */
    fetchStatsByContractId({ commit }, contractId) {
      return statsCustomer.getByContractId(contractId).then((response) => {
        if (response.data != "" && response.data.statsContract) {
          const dataStats = response.data.statsContract;
          dataStats.names = response.data.subFranchises.names || [];
          dataStats.totals = response.data.subFranchises.totals || [];
          dataStats.gimCustomNames =
            response.data.subFranchises.gimCustomNames || [];
          dataStats.gimCustomTotals =
            response.data.subFranchises.gimCustomTotals || [];
          dataStats.gimCustomPreviousYearNames =
            response.data.subFranchises.gimCustomPreviousYearNames || [];
          dataStats.gimCustomPreviousYearTotals =
            response.data.subFranchises.gimCustomPreviousYearTotals || [];
          dataStats.cost = response.data.deliveryCostAndBillingFees || [];
          dataStats.customer = response.data.customer;
          commit("setStatsCustomer", dataStats);
        } else {
          // Valeurs par défaut si pas de stats
          const statsNull = {
            capitalPoints: 0,
            implantPoints: 0,
            servicePoints: 0,
            manualPoints: 0,
            consommablePoints: 0,
            totalPoints: 0,
            totalPastYear: 0,
            statusPastYear: -1,
            totalCurrentYear: 0,
            customer: response.data.customer || {},
            names: [],
            totals: [],
          };
          commit("setStatsCustomer", statsNull);
        }
        return response;
      });
    },
    /**
     * Recalcule les points historiques pour un contrat à une date donnée
     */
    recalculateHistoricalPoints({ commit }, { contractId, targetDate }) {
      return statsCustomer
        .recalculateHistoricalPoints(contractId, targetDate)
        .then((response) => {
          if (response.data != "" && response.data.statsContract) {
            const dataStats = response.data.statsContract;
            dataStats.names = response.data.subFranchises?.names || [];
            dataStats.totals = response.data.subFranchises?.totals || [];
            dataStats.gimCustomNames =
              response.data.subFranchises?.gimCustomNames || [];
            dataStats.gimCustomTotals =
              response.data.subFranchises?.gimCustomTotals || [];
            dataStats.gimCustomPreviousYearNames =
              response.data.subFranchises?.gimCustomPreviousYearNames || [];
            dataStats.gimCustomPreviousYearTotals =
              response.data.subFranchises?.gimCustomPreviousYearTotals || [];
            dataStats.cost = response.data.deliveryCostAndBillingFees || [];
            dataStats.customer = response.data.customer;
            commit("setStatsCustomer", dataStats);
          }
          return response;
        });
    },
  },
};
